/**
 * Automations Page - Migrated to use EntitiesList
 *
 * This page now uses the generic EntitiesList component with
 * Automations-specific configuration for a standardized experience.
 */

import React from "react";
import { Link } from "react-router-dom";
import { PlusIcon } from "@heroicons/react/24/outline";

// Generic EntitiesList component and entity configurations
import EntitiesList from "../components/entities/EntitiesList";
import AutomationsConfig from "../components/entities/automations/AutomationsConfig";
import AutomationsColumns from "../components/entities/automations/AutomationsColumns";
import * as AutomationsMetrics from "../components/entities/automations/AutomationsMetrics";

// API hooks
import { useAutomations } from "../hooks/useApi";

/**
 * Automations Page Component
 *
 * Uses the generic EntitiesList with Automations-specific configuration
 * to provide a consistent, standardized experience.
 */
function Automations() {
  // API hooks for automations data
  const {
    items: automations = [],
    loading,
    error,
    refresh: refetch,
    clearError,
  } = useAutomations();

  // Custom Header Actions component for Automations
  const AutomationsHeaderActions = () => (
    <Link
      to="/new-automation"
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
      <PlusIcon className="h-4 w-4 mr-2" />
      New Automation
    </Link>
  );

  // Custom Empty State Actions for Automations
  const AutomationsEmptyStateActions = () => (
    <Link
      to="/new-automation"
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
    >
      <PlusIcon className="h-4 w-4 mr-2" />
      Create First Automation
    </Link>
  );

  return (
    <EntitiesList
      // Entity configuration
      entityConfig={AutomationsConfig}
      entityColumns={AutomationsColumns}
      entityMetrics={AutomationsMetrics}
      // Data and state
      entities={automations}
      loading={loading}
      error={error}
      // API functions
      refreshFunction={refetch}
      clearErrorFunction={clearError}
      // Custom components
      HeaderActions={AutomationsHeaderActions}
      EmptyStateActions={AutomationsEmptyStateActions}
      // Layout preferences
      layout="table"
    />
  );
}

export default Automations;
